(function () {
  'use strict';

  var config = window.LumiifloraAnimationsConfig || { enabled: true, heroParallax: true };
  var sectionTriggers = [];

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isEnabled() {
    return config.enabled !== false && !prefersReducedMotion();
  }

  function killAnimations() {
    sectionTriggers.forEach(function (trigger) {
      if (trigger && trigger.kill) trigger.kill();
    });
    sectionTriggers = [];

    if (window.ScrollTrigger) {
      ScrollTrigger.getAll().forEach(function (trigger) {
        trigger.kill();
      });
    }
  }

  function revealOnScroll(elements, options) {
    if (!elements) return;
    if (elements.length === 0) return;

    var fromVars = {
      opacity: 0,
      duration: options.duration || 0.85,
      stagger: options.stagger || 0.1,
      ease: options.ease || 'power2.out',
      scrollTrigger: {
        trigger: options.trigger,
        start: options.start || 'top 82%',
        toggleActions: 'play none none none'
      }
    };

    if (typeof options.x === 'number') {
      fromVars.x = options.x;
    } else {
      fromVars.y = options.y || 36;
    }

    var tween = gsap.from(elements, fromVars);

    if (tween.scrollTrigger) {
      sectionTriggers.push(tween.scrollTrigger);
    }
  }

  function initHeader() {
    var header = document.querySelector('#shopify-section-header, .shopify-section-group-header-group');
    if (!header) return;

    gsap.from(header, {
      y: -18,
      opacity: 0,
      duration: 0.7,
      ease: 'power2.out',
      delay: 0.1
    });
  }

  function initHero() {
    document.querySelectorAll('[data-section-type="section-slideshow-v5"]').forEach(function (section) {
      var firstSlide = section.querySelector('.item-slide');
      if (!firstSlide) return;

      var contentItems = firstSlide.querySelectorAll('.hero-split__content > *');
      var imageWrap =
        firstSlide.querySelector('.hero-split__image-wrap.d-none.d-md-block') ||
        firstSlide.querySelector('.hero-split__image-wrap.d-block.d-md-none') ||
        firstSlide.querySelector('.hero-split__image-wrap');

      // Opacity is forced visible via CSS (!important) to avoid clashes with legacy
      // slideshow styles — only animate translate so content cannot get stuck hidden.
      var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

      if (contentItems.length) {
        tl.fromTo(
          contentItems,
          { x: -28 },
          { x: 0, duration: 0.85, stagger: 0.12, clearProps: 'transform,x' },
          0.1
        );
      }

      if (imageWrap) {
        tl.fromTo(
          imageWrap,
          { x: 32 },
          { x: 0, duration: 1, clearProps: 'transform,x' },
          0.15
        );
      }
    });
  }

  function initFeatures() {
    document.querySelectorAll('[data-section-type="section-features"]').forEach(function (section) {
      var header = section.querySelector('.section-features__header');
      var cards = section.querySelectorAll('.section-features__col');

      if (header && header.children.length) {
        revealOnScroll(header.children, {
          trigger: section,
          y: 28,
          stagger: 0.12,
          duration: 0.8
        });
      }

      if (cards.length) {
        revealOnScroll(cards, {
          trigger: section.querySelector('.section-features__grid') || section,
          y: 40,
          stagger: 0.08,
          duration: 0.75,
          start: 'top 78%'
        });
      }
    });
  }

  function initProducts() {
    document.querySelectorAll('[data-section-type="section-product-v3"]').forEach(function (section) {
      var heading = section.querySelector('.text-center');
      var items = section.querySelectorAll('.section-product-v3__item');

      if (heading) {
        revealOnScroll(heading.children, {
          trigger: section,
          y: 24,
          stagger: 0.1,
          duration: 0.75
        });
      }

      if (items.length) {
        revealOnScroll(items, {
          trigger: section.querySelector('.section-product-v3__grid') || section,
          y: 36,
          stagger: 0.1,
          duration: 0.8,
          start: 'top 78%'
        });
      }
    });
  }

  function initTestimonials() {
    document.querySelectorAll('.lumiiflora-reviews-section').forEach(function (section) {
      var stars = section.querySelector('.lumiiflora-reviews__stars');
      var nav = section.querySelector('.lumiiflora-reviews__nav');

      if (stars) {
        revealOnScroll(stars, {
          trigger: section,
          y: 20,
          duration: 0.7,
          start: 'top 88%'
        });
      }

      if (nav) {
        revealOnScroll(nav, {
          trigger: section,
          y: 16,
          duration: 0.7,
          start: 'top 84%'
        });
      }
    });
  }

  function initTwoColumns() {
    document.querySelectorAll('[data-section-type="section-two-columns"]').forEach(function (section) {
      section.querySelectorAll('.section-two-columns__col').forEach(function (col, index) {
        var media = col.querySelector('.section-two-columns__media');
        var body = col.querySelector('.section-two-columns__body');

        if (media) {
          revealOnScroll(media, {
            trigger: col,
            x: index % 2 === 0 ? -40 : 40,
            y: 0,
            duration: 0.9,
            start: 'top 82%'
          });
        }

        if (body) {
          revealOnScroll(body.children, {
            trigger: col,
            y: 28,
            stagger: 0.08,
            duration: 0.75,
            start: 'top 80%'
          });
        }
      });
    });
  }

  function initFooter() {
    var footer = document.querySelector('.lumiiflora-footer, #shopify-section-footer');
    if (!footer) return;

    revealOnScroll(footer.querySelector('.lumiiflora-footer__top') || footer, {
      trigger: footer,
      y: 20,
      duration: 0.75,
      start: 'top 95%'
    });
  }

  function initAll() {
    if (!window.gsap || !window.ScrollTrigger) return;

    killAnimations();
    gsap.registerPlugin(ScrollTrigger);

    initHeader();
    initHero();
    initFeatures();
    initProducts();
    initTestimonials();
    initTwoColumns();
    initFooter();

    ScrollTrigger.refresh();
  }

  function boot() {
    if (!isEnabled()) {
      document.documentElement.classList.add('lf-animations-off');
      return;
    }

    if (window.gsap && window.ScrollTrigger) {
      initAll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    if (!isEnabled()) return;
    window.requestAnimationFrame(function () {
      initAll();
    });
  });

  document.addEventListener('shopify:section:unload', killAnimations);
})();
